/**
 * 统计各个模块的待处理事项
 */

import { getMyFeedbackStat, getSupportStat } from "@/service/cms/feedback";
import store from "@/store";
// import User from "@/utils/user";
// const isSuperAdmin = User.isSuperAdmin();

export const useCount = () => {
    // 统计我的待处理反馈工单
    // 包含协同的、被指派的，状态限制为1和2的
    // 统计未读的通知消息
    const countMyFeedback = async () => {
        await getMyFeedbackStat().then((res) => {
            const data = res.data.data;
            store.commit("app/SET_COUNTS", {
                key: "common-account-message",
                value: data?.message || 0,
            });
            store.commit("app/SET_COUNTS", {
                key: "common-account-feedback",
                value: data?.feedback || 0,
            });
        });
    };
    // 获取反馈统计
    const countSupport = async () => {
        await getSupportStat().then((res) => {
            const data = res.data.data;
            const contactValue = data?.contact || 0;
            const feedbackValue = data?.feedback || 0;
            store.commit("app/SET_COUNTS", {
                key: "omp-support-contact",
                value: contactValue,
            });
            store.commit("app/SET_COUNTS", {
                key: "omp-support-feedback",
                value: feedbackValue,
            });
            store.commit("app/SET_COUNTS", {
                key: "omp-support",
                value: contactValue + feedbackValue,
            });
        });
    };
    return {
        countMyFeedback,
        countSupport,
    };
};
